import { useNavigate } from "react-router-dom"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { Card } from "./ui/card"
import { ArrowLeft, Navigation, Phone } from "lucide-react"

const NavigationScreen = () => {
  const navigate = useNavigate()

  // This would come from an API in a real app
  const appointment = {
    id: 1,
    name: "Rahul Sharma",
    phone: "+91 98765 43210",
    address: "123 Main Street, Sector 18, Noida",
    distance: "3.2 km",
    eta: "15 min",
  }

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="relative h-[100px] w-[100px] mr-3">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-xl font-bold text-gray-800 truncate">Navigation</h1>
        </div>
      </div>

      <div className="relative w-full h-[60vh] bg-gray-100 rounded-lg mb-4 overflow-hidden">
        <img
          src="/placeholder.svg?height=600&width=400"
          alt="Map with navigation route"
          className="w-full h-full object-cover"
        />

        <div className="absolute top-4 right-4">
          <Button size="icon" variant="secondary" className="h-10 w-10 shadow-md bg-white border-gray-200">
            <Navigation className="h-5 w-5 text-gray-800" />
            <span className="sr-only">My Location</span>
          </Button>
        </div>
      </div>

      <Card className="p-4 border-gray-200">
        <div className="flex justify-between items-start mb-3">
          <div className="text-left">
            <h2 className="font-medium text-gray-800">{appointment.name}</h2>
            <p className="text-sm text-gray-500">{appointment.address}</p>
          </div>
          <div className="text-right">
            <div className="text-sm font-medium text-gray-800">{appointment.distance}</div>
            <div className="text-xs text-gray-500">ETA: {appointment.eta}</div>
          </div>
        </div>

        <div className="flex space-x-3 navigate-btn">
          <Button className="flex-1 bg-pranaam-red hover:bg-red-700 text-white">
            <Navigation className="h-4 w-4 mr-2" />
            Start Navigation
          </Button>

          <Button variant="outline" className="flex-1 border-gray-200 hover:bg-gray-50 text-gray-800">
            <Phone className="h-4 w-4 mr-2" />
            Call Patient
          </Button>
        </div>
      </Card>
    </AppLayout>
  )
}

export default NavigationScreen
